import React from "react";
import { Link } from "react-router-dom";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ActionFormatter({ row }) {
	return (
		<div>
			<Link
				to={{
					pathname: `/SpReviewedLeave/${row.id}`,
				}}
			>
				<button className="btnStyle" title="View Detail">
					<FontAwesomeIcon
						id="edit"
						className="hoverEffect"
						icon={faEye}
						size="1x"
					/>
				</button>
			</Link>
		</div>
	);
}

export default ActionFormatter;
